<template>
    <div class="invoice-status-wrap" :class="{ 'has-subbadge': !!getSubBadgeText(status) }" :key="'status_' + id">
        <b-tag class="primary-badge" :type="getTagType(status)">
            {{ (status === null || status === 'open') && send_at === null ? (type === 'credit' ? 'Open' : 'Ingepland') : invoiceStatus(status) }}
        </b-tag>

        <b-tag :type="subBadgeType ? subBadgeType : getTagType(status)" v-if="getSubBadgeText(status)" class="secondary-badge">
            <template v-if="getSubBadgeText(status).startsWith('icon_')">
                <b-tooltip :label="`Opnieuw ingepland voor ${getPlannedPaymentDate()}`" style="display: flex;justify-content: center;align-content: center;">
                    <font-awesome-icon :icon="getSubBadgeText(status).substring(6, getSubBadgeText(status).length - 1).split(',').map(item => item.trim())" />
                </b-tooltip>
            </template>
            <template v-else>
                <span v-html="getSubBadgeText(status)"></span>
            </template>
        </b-tag>

        <span v-show="((contractOrInvoicePaymentTypeManual) && !_.isNull(send_at) && status !== 'paid' && status !== 'cancelled') || (type == 'credit' && _.isNull(send_at) && status !== 'paid' && status !== 'cancelled')" style="position: relative;left: -12px;top: -8px;">
            <b-tooltip label="Betaling handmatig registreren">
                <b-icon icon="exclamation-circle" type="is-danger" />
            </b-tooltip>
        </span>

        <EscalationOptionsDropdown
            v-if="id && showEscalationDropdown"
            :id="id"
            :status="status"
            @reload="$emit('reload')"
        />
    </div>
</template>

<script>
import InvoiceStatusMixin from '@/mixins/invoiceStatusMixin.js'
import EscalationOptionsDropdown from '@/vue/invoices/components/EscalationOptionsDropdown.vue'

export default {
    name: 'InvoiceStatus',

    mixins: [InvoiceStatusMixin],

    components: {
        EscalationOptionsDropdown
    },

    props: {
        id: {
            type: Number,
            required: false,
            default: null
        },
        status: {
            type: String,
            required: false,
            default: null
        },
        send_at: {
            type: String,
            required: false,
            default: null
        },
        type: {
            type: String,
            required: false,
            default: 'recent'
        },
        contract: {
            type: Object,
            required: false,
            default: null
        },
        payments: {
            type: Array,
            required: false,
            default: () => []
        },
        showEscalationDropdown: {
            type: Boolean,
            required: false,
            default: false
        }
    },

    computed: {
        subBadgeType() {
            // If the subbadge text starts with 'icon_', we want to make the badge primary
            return this.getSubBadgeText(this.status) && this.getSubBadgeText(this.status).startsWith('icon_') ? 'is-dark' : false
        },
        tooltipHelptext() {
            return 'Handmatige actie vereist' + (_.isNull(this.send_at) ? ' na verzending' : '')
        },
        contractOrInvoicePaymentTypeManual() {
            const hasManualPayment =
                (this.contract && this.contract.payment_type == 'manual') ||
                this.payments.some(payment => payment.type == 'manual' && payment.status !== 'cancelled')

            const hasPlannedIncasso = this.payments.some(payment =>
                payment.type === 'incasso' &&
                ['planned', 'incasso_planned', 'incasso_planned_bank', 'pending_mandate'].includes(payment.status)
            )

            return hasManualPayment && !hasPlannedIncasso
        }
    },

    methods: {
        getPlannedPaymentDate() {
            if (!this.payments || !this.payments.length) return '';

            const plannedPayment = [...this.payments]
                .filter(payment => payment.status === 'planned')
                .sort((a, b) => new Date(b.payment_date) - new Date(a.payment_date))[0];

            if (!plannedPayment) return '';

            return new Date(plannedPayment.payment_date).toLocaleDateString('nl-NL', {
                day: '2-digit',
                month: '2-digit',
                year: 'numeric'
            }).replace(/\//g, '-');
        },

        getTagType(status) {
            switch (status) {
                case null:
                case 'open_due':
                    if (_.isNull(this.send_at) && this.type != 'credit') {
                        return 'is-light'
                    }
                    return 'is-dark'
                case 'paid':
                case 'escalated_done':
                    return 'is-success'
                case 'multiple_fails':
                case 'storno':
                case 'error':
                case 'no_payment':
                    return 'is-danger'
                case 'one_fail':
                    return 'is-warning'
                case 'cancelled':
                case 'reminder_1':
                case 'reminder_2':
                    return 'is-warning'
                case 'reminder_3':
                    return 'is-danger'
                case 'escalated':
                case 'escalated_send':
                    return 'is-black'
                case 'hold':
                default:
                    return 'is-info'
            }
        },

        getSubBadgeText(status) {
            switch (status) {
                case 'multiple_fails':
                    if (this.payments.some(payment => payment.status === 'planned')) {
                        return `icon_[fas, redo]`
                    } else if (this.payments.some(payment => payment.status === 'failed')) {
                        const failedPayments = this.payments.filter(payment => payment.status === 'failed')
                        return failedPayments.length > 1 ? failedPayments.length + 'x' : false
                    }
                case 'storno':
                if (this.payments.some(payment => payment.status === 'planned')) {
                        return `icon_[fas, redo]`
                    } else if (this.payments.some(payment => payment.status === 'storno')) {
                        const failedPayments = this.payments.filter(payment => payment.status === 'storno')
                        return failedPayments.length > 1 ? failedPayments.length + 'x' : false
                    }
                default:
                    return false
            }
        }
    }
}
</script>
